import { render, staticRenderFns } from "./StageHeader.vue?vue&type=template&id=8150d0f4&scoped=true&"
import script from "./StageHeader.vue?vue&type=script&lang=ts&"
export * from "./StageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StageHeader.vue?vue&type=style&index=0&id=8150d0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8150d0f4",
  null
  
)

export default component.exports